module.exports = __webpack_public_path__ + "img/step.af606cfd.png";